import { z } from "zod"

export const presignDriverDocSchema = z.object({
  fileName: z.string().min(1).max(200),
  mimeType: z.string().min(1).max(100),
})

export const createDriverDocSchema = z.object({
  fileKey:  z.string().min(1),
  mimeType: z.string().max(100).nullable().optional(),
  notes:    z.string().max(1000).nullable().optional(),
})

export type PresignDriverDocInput = z.infer<typeof presignDriverDocSchema>
export type CreateDriverDocInput  = z.infer<typeof createDriverDocSchema>
